

























import { userModule } from "@/store/modules/user";

export default {
  name: "HeartFailureIndicator",
  props: {
    active: Boolean,
    toggleProgress: {
      require: false,
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "25"
    }
  },
  data() {
    return {
      // toggleProgress: false
    };
  },
  methods: {
    // active: true,
    toggleActive() {
      if (this.canSetRegHF) {
        this.$emit("toggleActive");
      }
    }
  },
  computed: {
    text() {
      return this.active
        ? "Pasien dengan Register Heart Failure"
        : "Klik untuk menandai Pasien Register Heart Failure";
    },
    canSetRegHF() {
      return ["27"].includes(userModule.user.unit_group_id);
    }
  }
};
